<template>
  <button
    v-if="getAction(record).visible"
    class="btn-small u-inline"
    v-bind:class="getAction(record).class"
  >
    <router-link :to="{ name: 'record-detail', params: { id: record.id } }">
      {{ getAction(record).label }}
    </router-link>
  </button>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "record-action-button",
  props: ["record"],
  computed: {
    ...mapGetters("auth", ["userProfile", "permissions"])
  },
  methods: {
    getAction: function(record) {
      var result = { visible: false, label: "", class: "" };
      const _is_candidate = record.candidate.id == this.userProfile.id;
      const _is_instructor = record.instructor_id == this.userProfile.id;
      const _is_involved = _is_candidate || _is_instructor;
      if (_is_instructor && !record.is_closed) {
        // Instructor can complete owned records that aren't closed
        result.visible = true;
        result.label = "Complete";
        result.class = "btn-primary";
      } else if (
        this.permissions.includes("records.view_record") ||
        _is_involved
      ) {
        // Can view records if have the view permission OR if involved in the record
        result.visible = true;
        result.label = "View";
        result.class = "btn-info outline";
      }
      return result;
    }
  }
};
</script>
